const style = {
  artistName: {
    color: "#fff",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "none",
      color: "#fff",
    },
  },
  featuredSongsSection: {
    backgroundColor: "#0c091b",
    maxWidth: "1280px",
    margin: "auto",
    paddingBottom: "60px",
  },
  featuredRow: {
    padding: "60px 25px 0",
    width: "100%",
    "@media (max-width:767px)": {
      padding: "0 15px",
    },
  },
  haveQuestion: {
    padding: "60px 25px 0",
    width: "100%",
    display: "none",
    "@media (max-width:767px)": {
      padding: "0 15px",
      display: "block",
    },
  },

  whatsApp: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    padding: "10px 15px",
    border: "1px solid rgba(255,255,255,0.4)",
    borderRadius: "10px",
    background: "#1e1b3d",
    cursor: "pointer",
    width: "180px",
    height: "40px",
    zIndex: "100",
    "& img": {
      marginRight: "12px",
    },
    "@media(max-width:767px)": {
      padding: "0",
      "& img": {
        width: "24px",
        height: "24px",
      },
    },
  },
  counterLine: {
    position: "relative",
    display: "block",
    width: "60px",
    borderRadius: "10px",
    height: "7px",
    background: "#E14084",
    "@media (max-width:767px)": {
      marginLeft: "15px",
    },
  },
  featuredRowTop: {
    padding: "30px 25px 0",
    display: "flex",
    flexWrap: "wrap",
    "@media (max-width:767px)": {
      padding: "0 15px",
    },
  },
  featuredBoxSingle: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    maxWidth: "1280px",
    alignItems: "start",
    marginTop: "20px",
    "@media (max-width:767px)": {
      flexWrap: "wrap",
    },
  },
  featuredCardImageBoxSingle: {
    position: "relative",
    display: "flex",
    width: "100%",
    maxWidth: "767px",
    overflow: "hidden",
    "& img": {
      width: "100%",
      borderRadius: "20px",
      height: "100%",
      objectFit: "cover",
    },
    "@media (max-width:767px)": {
      flexWrap: "wrap",
      flexDirection: "column-reverse",
      "& > div": {
        width: "100%",
      },
    },
  },
  imgLgContainer: {
    // width: "100%",
    // height: "90%",
    marginLeft: "20px",
    margin: "auto 0 0 20px",
    "@media (max-width:480px)": {
      minWidth: "100%",
      marginLeft: "0px",
      "& img": {
        maxHeight: "315px !important",
        maxWidth: "100% !important",
      },
    },
    "& img": {
      objectFit: "fill",
    },
  },
  songThumbnailList: {
    position: "relative",
    display: "block",
    padding: "0",
    maxHeight: "430px",
    overflowY: "scroll",
    "& li": {
      position: "relative",
      display: "block",
      paddingRight: "16px",
      cursor: "pointer",
      // opacity: "0.6",
      "& img": {
        width: "78px",
        height: "78px",
        objectFit: "fill",
        borderRadius: "8px",
      },
      "@media(max-width:992px)": {
        textAlign: "center",
        width: "auto",
        margin: "0 5px",
      },
    },
    "& li.active": {
      opacity: "1",
      "& img": {
        border: "3px solid #FFFFFF",
      },
    },
    "@media(max-width:767px)": {
      display: "flex",
      justifyContent: "center",
      marginTop: "24px",
      "& li": {
        position: "relative",
        display: "block",
        padding: "0",
        "& img": {
          width: "64px",
          height: "64px",
        },
      },
      "& li.active": {
        opacity: "1",
        "& img": {
          border: "3px solid #FFFFFF",
        },
      },
    },
  },
  featuredSingleTitle: {
    position: "relative",
    display: "flex",
    // width: "50%",
    minWidth: "320px",
    "@media (max-width:763px)": {
      marginLeft: "10px",
    },
  },
  songNameContent: {
    marginLeft: "-40px",
    marginBottom: "30px",
    width: "100%",
    "@media (max-width:930px)": {
      marginLeft: "-40px",
    },
  },
  songDate: {
    transform: "rotateZ(-90deg) translateX(-43px) translateY(-33px)",
    color: "#E14084",
    fontWeight: "700",
    display: "block",
    padding: "5px 0",
    borderBottom: "1px solid rgba(255, 255, 255, 0.5)",
    height: "30px",
    fontSize: "16px",
    textTransform: "uppercase",
    whiteSpace: "nowrap",

    "@media (max-width:930px)": {
      transform: "rotateZ(-90deg) translateX(-43px) translateY(-31px)",
    },
    "@media (max-width:767px)": {
      fontSize: "10px",
      fontWeight: "600",
      transform: "rotateZ(-90deg) translateX(-27px) translateY(-33px)",
      height: "25px",
    },
  },
  songName: {
    color: "#fff",
    fontSize: "42px",
    fontWeight: "700",
    "@media(max-width:767px)": {
      fontSize: "28px",
      fontWeight: "600",
    },
  },
  singerName: {
    display: "flex",
    color: "#fff",
    alignItems: "center",
    marginTop: "5px",
    fontSize: "24px",
    "& img": {
      width: "39px",
      height: "39px",
      objectFit: "cover",
      borderRadius: "50%",
    },
    "& small": {
      padding: "0 12px",
      fontSize: "24px",
    },
    "@media(max-width:767px)": {
      "& img": {
        width: "24px",
        height: "24px",
      },
      "& small": {
        fontWeight: "500",
        fontSize: "16px",
      },
    },
  },
  songDescription: {
    color: "rgba(255,255,255,255)",
    fontSize: "20px !important",
    // textAlign: "justify",
    marginBottom: "24px",
    "& span": {
      color: "#E14084",
      fontSize: "16px",
      fontWeight: "500",
      paddingLeft: "0",
    },
    "@media (max-width:767px)": {
      fontSize: "14px",
      fontWeight: "400",
      marginTop: "20px",
    },
  },
  Dropping: {
    paddingLeft: "45px",
    position: "relative",
    width: "50%",
    minWidth: "320px",
    "& span": {
      color: "#fff",
      fontSize: "16px",
      fontWeight: "500",
      display: "block",
      paddingLeft: "0",
    },
    "@media (max-width:767px)": {
      paddingLeft: "0",
    },
  },
  SongVideos: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
    padding: "0 20px",
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  SongAudio: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
    padding: "0 20px",
    width: "10%",
    height: "10%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  songDetails: {
    // paddingLeft: "45px",
    position: "relative",
    width: "100%",
    minWidth: "320px",
    "& span": {
      color: "#fff",
      fontSize: "16px",
      fontWeight: "500",
      display: "block",
    },
    "@media (max-width:767px)": {
      paddingLeft: "0",
      marginTop: "20px",
      display: "flex",
      flexWrap: "wrap",
      flexDirection: "column-reverse",
    },
    "@media (max-width:480px)": {
      minWidth: "100%",
    },
  },
  featuredCardContentSingle: {
    position: "relative",
    width: "100%",
    "@media (max-width:767px)": {
      marginTop: "20px",
      position: "relative",
      display: "block",
      width: "100%",
    },
  },
  countDown: {
    fontSize: "45px",
    color: "#fff",
    fontWeight: "600",
    "@media (max-width:767px)": {
      "& h4": {
        fontSize: "28px",
        fontWeight: "400",
      },
    },
  },
  shareContainer: {
    display: "flex",
    justifyContent: "space-between",
    padding: "0 30px 0 0",
    "@media(max-width:767px)": {
      paddingLeft: "15px",
      paddingRight: "0px",
    },
  },
  linkShare: {
    position: "relative",
    fontSize: "18px",
    fontWeight: "400",
    display: "flex !important",
    alignItems: "center",
    cursor: "pointer",
    "& span": {
      marginLeft: "7px",
    },
    "@media(max-width:767px)": {
      "& span": {
        display: "none",
      },
    },
  },
  socialShareinglist: {
    position: "absolute",
    transform: "translateX(-50%)",
    display: "block",
    width: "168px",
    background: "#1F1B2E",
    padding: "28px 26px",
    border: "1px solid rgba(255, 255, 255, 0.3)",
    borderRadius: "8px",
    zIndex: "11",

    "& li": {
      padding: "0",
    },
    "& li a p": {
      fontSize: "14px !important",
      fontWeight: "400 !important",
      textTransform: "capitalize",
    },
    "& li a img": {
      width: "20px !important",
      height: "20px !important",
    },
    "& li:last-child a": {
      marginBottom: "0",
    },
    "& li a": {
      position: "relative",
      display: "flex",
      alignItems: "center",
      marginBottom: "19px",
      color: "#fff !important",
      "& img": {
        marginRight: "14px",
      },
    },
  },
  socialShareingNft: {
    position: "absolute",
    top: "100%",
    left: "50%",
    transform: "translateX(-50%)",
    display: "block",
    width: "168px",
    background: "#1F1B2E",
    padding: "28px 26px",
    border: "1px solid rgba(255, 255, 255, 0.3)",
    borderRadius: "8px",
    zIndex: "11",
    maxWidth: "initial",
    "& li": {
      padding: "0",
    },
    "& li a p": {
      fontSize: "14px !important",
      fontWeight: "400 !important",
      textTransform: "capitalize",
    },
    "& li a img": {
      width: "20px !important",
      height: "20px !important",
    },
    "& li:last-child a": {
      marginBottom: "0",
    },
    "& li a": {
      position: "relative",
      display: "flex",
      alignItems: "center",
      marginBottom: "19px",
      color: "#fff !important",
      "& img": {
        marginRight: "14px",
      },
    },
  },
  tableCount: {
    marginLeft: "-18px",
    width: "100%",
    maxWidth: "400px",
    "& td": {
      padding: "16px 16px 16px 0",
      borderBottom: "none",
      width: "50px",
    },
    "& td h3": {
      fontWeight: "500",
    },
    "@media (max-width:930px)": {
      marginLeft: "0",
    },
  },
  buttonSet: {
    display: "flex",
    justifyContent: "space-between",
  },
  featuredBuyNow: {
    position: "relative",
    textAlign: "center",
    display: "block",
    width: "100%",
    maxWidth: "360px",
    background: "linear-gradient(90deg,#E14084,#3454FA,#54B5BB)",
    marginTop: "30px",
    borderRadius: "10px",
    height: "56px",
    lineHeight: "56px",
    color: "#fff !important",
    textTransform: "capitalize",
    textDecoration: "none !important",
    fontSize: "16px",
    fontWeight: "600",
  },
  featuredCardTitle: {
    fontWeight: "400",
    fontSize: "24px",
    color: "#fff",
    fontWeight: "600",
    "& span": {
      fontWeight: "600",
      fontSize: "24px",
      color: "#FFF",
      // color: "#E14084",
      display: "flex",
      alignItems: "center",
      justifyContent: "end",
    },
    "@media(max-width:767px)": {
      fontWeight: "600",
      fontSize: "20px",
    },
  },
  featuredCardSubTitle: {
    fontWeight: "100",
    fontSize: "16px",
    color: "#fff",
    "@media(max-width:767px)": {
      fontWeight: "400",
      fontSize: "14px",
    },
  },
  featuredStats: {
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    marginTop: "20px",
    width: "100%",
  },
  songMsg: {
    fontSize: "14px",
    color: "#c2c1c6",
    marginTop: "30px",
    "& img:first-child": {
      padding: "5px 10px",
      background: "#0C091B",
      border: "1px solid rgba(255, 255, 255, 0.2)",
      borderRadius: "6px",
      margin: "0 6px",
    },
    "& img:last-child": {
      padding: "3px 10px",
      background: "#fff",
      border: "1px solid rgba(255, 255, 255, 0.2)",
      borderRadius: "6px",
      margin: "0 6px",
    },
    "@media(max-width:767px)": {
      fontSize: "12px",
      marginBottom: "30px",
      "& img:first-child": {
        padding: "5px 5px",
        width: "60px",
      },
      "& img:last-child": {
        padding: "0px",
        width: "60px",
      },
    },
  },
  tokenSectionTitle: {
    color: "#fff",
    fontSize: "42px",
    fontWeight: "700",
    marginBottom: "20px",
    textTransform: "capitalize",
    "@media(max-width:480px)": {
      fontSize: "24px",
      letterSpacing: "1px",
      fontWeight: "600",
      marginTop: "24px",
    },
  },
  featuredBox: {
    position: "relative",
    display: "flex",
    flexWrap: "wrap",
    width: "50%",
    padding: "15px 15px 0 0",
    "@media (max-width:992px)": {
      width: "100%",
      maxWidth: "590px",
      justifyContent: "center",
    },
  },
  packageBox: {
    position: "relative",
    display: "flex",
    width: "100%",
    marginTop: "15px",
    paddingLeft: "12px",
    paddingRight: "0",
    paddingBottom: "12px",
    paddingTop: "12px",
    background: "#fff",
    borderRadius: "10px",
    cursor: "pointer",
    "& > img": {
      width: "100%",
      maxWidth: "146px",
    },
    "& > div": {
      width: "100%",
      padding: "0 15px",
    },
    "@media (max-width:767px)": {
      display: "block",
      "& > img": {
        display: "block",
        margin: "auto",
        marginBottom: "20px",
      },
    },
  },
  mobilePackageBox: {
    position: "relative",
    display: "none",
    width: "100%",
    background: "#fff",
    borderRadius: "10px",
    padding: "12px",
    marginBottom: "24px",
    "@media (max-width:767px)": {
      display: "block",
    },
    "& > div": {
      "@media (max-width:767px)": {
        display: "flex",
        "& > img": {
          width: "88px",
          marginBottom: "20px",
          margin: "auto",
        },
      },
    },
  },
  boxRow: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    "@media (max-width:992px)": {
      justifyContent: "space-around",
    },
  },
  tokenContentTitle: {
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
  },
  tokenBtn: {
    position: "absolute",
    display: "flex",
    justifyContent: "end",
    bottom: "15px",
    right: "20px",
    "@media(max-width:767px)": {
      position: "relative",
      bottom: "0",
      right: "0px",
    },
  },
  minusbtokenbtn: {
    // boxSizing: "border-box",
    display: "flex",
    // flexDirection: "row",
    width: "25px",
    minWidth: "25px !important",
    height: "25px",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid #D9D9D9",
    fontWeight: 600,
    fontSize: "20px",
    marginLeft: "15px",
  },
  addbtokenbtn: {
    // boxSizing: "border-box",
    display: "flex",
    // flexDirection: "row",
    width: "25px",
    minWidth: "25px !important",
    height: "25px",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid #E14084",
    color: "#E14084",
    fontSize: "20px",
    paddingTop: " 0px",
    fontWeight: 600,
    marginRight: "40px",
  },
  packageName: {
    fontSize: "24px",
    fontWeight: "600",
    "@media (max-width:767px)": {
      fontSize: "20px",
      fontWeight: "600",
    },
  },
  packagePrice: {
    fontSize: "24px",
    fontWeight: "600",
    color: "#E14084",
    "@media (max-width:767px)": {
      fontSize: "20px",
      fontWeight: "600",
    },
  },
  packageSubTitle: {
    fontSize: "16px",
    fontWeight: "600",
    marginTop: "10px",
    "@media (max-width:767px)": {
      fontSize: "14px",
      fontWeight: "600",
    },
  },
  packageBenefitsTitle: {
    fontSize: "18px",
    fontWeight: "600",
    marginTop: "10px",
    display: "flex",
    alignItems: "center",
    "& img": {
      width: "18px",
      marginRight: "5px",
    },
    "@media (max-width:767px)": {
      fontSize: "16px",
      fontWeight: "600",
      marginTop: "5px",
    },
  },
  benefitListBox: {
    position: "relative",
    display: "block",
  },
  packageBenefitsList: {
    fontSize: "16px",
    marginTop: "8px",
    display: "flex",
    alignItems: "center",
    "& img": {
      width: "12px",
      height: "9px",
      marginRight: "7px",
      marginTop: "7px",
      display: "flex",
      alignSelf: "flex-start",
    },
    "@media (max-width:767px)": {
      fontSize: "14px",
      marginTop: "5px",
    },
  },
  soldout: {
    display: "inline",
    fontSize: "20px",
    textAlign: "center",
    textDecoration: "none",
    color: "#E14084",
  },
  moreInfoLink: {
    display: "block",
    textDecoration: "none",
    marginTop: "10px",
    marginBottom: "8px",
    fontWeight: "500",
    color: "#E14084",
    fontWeight: "600",
    "&:hover": {
      textDecoration: "none",
      color: "#E14084",
      fontWeight: "600",
    },
  },
  dividerLine: {
    position: "relative",
    display: "block",
    height: "1px",
    margin: "0 -10px",
    background: "#bfbfbf",
    marginBottom: "15px",
  },
  availToken: {
    fontSize: "16px",
    paddingTop: "5px",
    marginRight: "5px",
    paddingLeft: "2px",
  },
  tokenBuyNow: {
    position: "relative",
    textAlign: "center",
    display: "block",
    padding: "10px 20px",
    background: "linear-gradient(90deg,#E14084,#3454FA,#54B5BB)",
    borderRadius: "10px",
    textTransform: "capitalize",
    fontWeight: "600",
    color: "#fff",
    maxHeight: "49px",
    "@media(max-width:767px)": {
      paddingInline: "10 !important",
      maxHeight: "60px",
    },
  },
  btnUpload: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    padding: "12px",
    width: "48px",
    height: "48px",
    marginRight: "16px",
    minWidth: "initial",
    border: "1px solid rgba(0, 0, 0, 0.9)",
    borderRadius: "12px",
    "& img": {
      width: "24px",
      height: "24px",
    },
  },
  chartContainer: {
    position: "relative",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    width: "100%",
    marginTop: "30px",
    padding: "60px 30px",
    borderRadius: "20px",
    background: "#242033",
    "@media(max-width:767px)": {
      padding: "20px 0",
    },
  },
  pieChartBox: {
    position: "relative",
    display: "block",
    width: "100%",
    maxWidth: "485px",
    textAlign: "center",
    color: "#fff",
    "& p": {
      fontSize: "28px",
    },
    "& svg": {
      position: "relative",
      display: "true",
      width: "100%",
      maxWidth: "384px",
      margin: "auto",
    },
  },
  listBox: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
  },
  listItemBox: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "20px",
    border: "1px solid #bfbfbf",
    width: "100%",
    maxWidth: "257px",
    minHeight: "140px",
    textAlign: "center",
    color: "#fff",
    marginLeft: "30px",
    marginBottom: "30px",
    "& small": {
      position: "relative",
      display: "block",
      fontSize: "18px",
      marginBottom: "10px",
      color: "#b4b2b9",
    },
    "& p": {
      fontSize: "24px",
      margin: "0",
    },
    "@media (max-width:767px)": {
      width: "48%",
      maxWidth: "initial",
      marginLeft: "7px",
      marginBottom: "7px",
      minHeight: "90px",
      borderRadius: "10px",
      "& small": {
        fontSize: "14px",
      },
      "& p": {
        fontSize: "16px",
        fontWeight: "600",
        margin: "0",
      },
    },
    "@media (max-width:480px)": {
      width: "46%",
      "& p": {
        fontSize: "17px",
      },
    },
  },
  question: {
    fontSize: "24px",
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    "& svg": {
      width: "1.5em",
      height: "1.5em",
    },
  },
  answer: {
    fontSize: "17px",
    fontWeight: "300",
  },
  faqDivider: {
    margin: "40px 0",
    borderWidth: "0",
    borderStyle: "solid",
    borderColor: "rgb(255 255 255 / 26%)",
    borderBottomWidth: "thin",
  },
  tableUI: {
    color: "#fff",
    fontSize: "18px",
    fontWeight: "500",
    borderRadius: "20px",
    borderCollapse: "collapse",
    marginBottom: "40px",
    border: "1px solid rgba(255,255,255,0.5)",
    "& tr:nth-child(even)": {
      background: "rgba(255, 255, 255, 0.1)",
    },
    "& thead th": {
      padding: "24px 0",
      border: "1px solid rgba(255,255,255,0.5)",
      borderCollapse: "collapse",
      textAlign: "center",
      fontSize: "20px",
      fontWeight: "600",
      background: "rgba(255, 255, 255, 0.1)",
    },
    "& thead th:first-child": {
      textAlign: "left",
    },
    "& tbody td": {
      padding: "24px",
      border: "1px solid rgba(255,255,255,0.5)",
      borderCollapse: "collapse",
      textAlign: "center",
      fontSize: "14px",
      color: "#fff",
      // minHeight:"94px",
    },
  },
  DesktoptableUI: {
    color: "#fff",
    fontSize: "18px",
    fontWeight: "500",
    borderRadius: "20px",
    borderCollapse: "collapse",
    marginBottom: "40px",
    border: "1px solid rgba(255,255,255,0.5)",
    "& tr:nth-child(even)": {
      background: "rgba(255, 255, 255, 0.1)",
    },
    "& thead th": {
      padding: "24px 0",
      border: "1px solid rgba(255,255,255,0.5)",
      borderCollapse: "collapse",
      textAlign: "center",
      fontSize: "20px",
      fontWeight: "600",
      background: "rgba(255, 255, 255, 0.1)",
    },
    "& thead th:first-child": {
      textAlign: "left",
    },
    "& tbody td": {
      padding: "10px 16px 10px 16px",
      border: "1px solid rgba(255,255,255,0.5)",
      borderCollapse: "collapse",
      textAlign: "center",
      fontSize: "18px",
      color: "#fff",
      // minHeight:"94px",
    },
  },
  loveCounter: {
    position: "absolute",
    top: "0",
    right: "4px",
    fontSize: "9px",
    fontWeight: 600,
    color: "#e14085",
  },
  statsContainer: {
    width: "90%",
    padding: "20px",
    fontFamily: "Inter",
    margin: "48px auto 20px",
    display: "flex",
    justifyContent: "space-evenly",
    background: "#242033",
    color: "white",
    display: "flex",
    alignItems: "center",
    borderRadius: "20px",
    "@media(max-width:767px)": {
      flexDirection: "column",
      justifyContent: "center",
      margin: "auto",
      marginTop: "5px",
      marginBottom: "25px",
      width: "100%",
    },
  },
  details: {
    margin: "auto",
    display: "flex",
    alignItems: "center",
    "& > div": {
      padding: "0 12px",
      "@media(max-width:480px)": {
        display: "flex",
        alignItems: "center",
      },
    },
    "& > div span": {
      display: "block",
      width: "100%",
    },
    "@media(max-width:767px)": {
      margin: "auto",
      width: "90%",
      marginBottom: "25px",
    },
  },
  tab: {
    fontWeight: "400",
    fontSize: "16px",
    textAlign: "left",
    lineHeight: "40px",
    "@media(max-width:480px)": {
      fontSize: "12px",
      width: "auto",
      marginLeft: "10px",
      lineHeight: "normal",
    },
  },
  userName: {
    fontSize: "36px",
    fontWeight: "600",
    lineHeight: "40px",
    textAlign: "left",
    minWidth: "111px",
    "@media(max-width:480px)": {
      whiteSpace: "nowrap",
      fontSize: "25px",
    },
  },
  releaseDate: {
    textAlign: "left",
    fontSize: "12px",
    fontWeight: "500",
    color: "#fff",
    opacity: "0.75",
    lineHeight: "24px",
  },
  tblBody: {
    "& td": {
      padding: "16px !important",
      fontWeight: "500 !important",
    },
    "& td:first-child img": {
      width: "40px",
      height: "40px",
      border: "1px solid #FFFFFF",
      borderRadius: "4px",
    },
  },
  tblsongName: {
    textAlign: "left",
    fontSize: "14px",
    fontWeight: "500",
    paddingLeft: "8px",
  },
  views: {
    textAlign: "center",
    fontSize: "20px",
    fontWeight: "700",
    paddingLeft: "8px",
    fontStyle: "italic",
    lineHeight: 1.3,
  },
  DesktopTblsongName: {
    textAlign: "left",
    fontSize: "18px",
    fontWeight: "500",
    paddingLeft: "12px",
  },
  breadCrumb: {
    fontSize: "16px",
    fontWeight: "400",
    color: "#fff",
    margin: "20px auto 0",
    padding: "0 25px",
    display: "block",
    maxWidth: "1280px",
    color: "rgba(255,255,255,0.7)",
    "& a": {
      color: "#E14084",
      textDecoration: "none",
    },
    "@media(max-width:767px)": {
      fontSize: "14px",
      marginBottom: "20px",
    },
  },
  HItWork: {
    fontWeight: "100",
    fontSize: "14px",
    color: "#E14084",
    fontWeight: "700",
    textDecoration: "underline",
    "@media(max-width:767px)": {
      fontWeight: "400",
      fontSize: "12px",
      fontWeight: "700",
      textDecoration: "underline",
    },
  },
  HIWtitle: {
    textAlign: "center",
    color: "#fff",
    fontSize: "42px",
    fontWeight: "700",
    lineHeight: "51px",
    // paddingLeft: "100px",
    "@media (max-width:480px)": {
      fontSize: "24px",
      fontWeight: "600",
      marginBottom: "20px",
    },
  },
  headerItems: {
    padding: "40px 15px 0",
    // maxWidth: "600px",
    // margin: "auto",
    background: "#19132A",
    position: "relative",
    display: "flex",
    "@media(max-width:767px)": {
      flexWrap: "wrap",
      justifyContent: "center",
    },
  },

  performanceContainer: {
    marginTop: "40px",
    width: "1208px",
    height: "100px",
    background: "#242033",
    borderRadius: "20px",
    alignItems: "center",
    display: "flex",
    paddingInline: "30px",
    "@media(max-width:767px)": {
      width: "100%",
      marginTop: "20px",
    },
  },
  performanceText: {
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "24px",
    lineHeight: "29px",
    color: "#FFFFFF",
    "@media(max-width:767px)": {
      fontSize: "18px",
    },
  },
  performanceTitle: {
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: "42px",
    lineHeight: "51px",
    color: "#FFFFFF",
    "@media(max-width:767px)": {
      fontSize: "24px",
    },
  },
  whatsAppDesktop: {
    right: "0px",
    bottom: "0px",
    width: "100%",
    maxWidth: "430px",
    marginTop: "20px",
    height: "70px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: "#fff",
    padding: "10px 15px",
    // border: "1px solid rgba(255,255,255,0.4)",
    // background: "#1e1b3d",
    cursor: "pointer",
    zIndex: "100",
    "& img": {
      marginRight: "12px",
    },
    "@media(max-width:767px)": {
      padding: "0",
      border: "none",
      "& span": {
        display: "none",
      },
      "& img": {
        width: "24px",
        height: "24px",
      },
    },
  },
  btnConfirm: {
    position: "relative",
    textAlign: "center",
    display: "block",
    fontWeight: "600",
    fontSize: "16px",
    width: "49%",
    maxWidth: "200px",
    background: "linear-gradient(90deg,#E14084,#3454FA,#54B5BB)",
    borderRadius: "10px",
    height: "56px",
    color: "#fff",
    textDecoration: "none",
    textTransform: "capitalize",
    // paddingTop: "8px",
  },
  returnCalculator: {
    fontFamily: "Inter",
    fontStyle: "normal",
    width: "49%",
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "36px",
    color: "#fff ",
    borderRadius: "10px",
    border: "1px solid white",
    height: "56px",
    maxWidth: "200px",
    textDecoration: "none",
    textTransform: "capitalize",
  },
};
export default style;
